import { useEffect } from 'react';

const useCarousel = (carouselId) => {
  useEffect(() => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      var tns = require('tiny-slider').tns;

      function updateTabIndex(item, tabIndex) {
        item.querySelector('.c-carousel-card__badge-title') !== null &&
          item.querySelector('.c-carousel-card__badge-title').setAttribute('tabindex', tabIndex);
        item.querySelector('.c-carousel-card__badge-subtitle') !== null &&
          item.querySelector('.c-carousel-card__badge-subtitle').setAttribute('tabindex', tabIndex);
        item.querySelector('.c-carousel-card__title') !== null &&
          item.querySelector('.c-carousel-card__title').setAttribute('tabindex', tabIndex);
        item.querySelector('.c-carousel-card__subtitle') !== null &&
          item.querySelector('.c-carousel-card__subtitle').setAttribute('tabindex', tabIndex);
        item.querySelector('.c-carousel-card__description') !== null &&
          item.querySelector('.c-carousel-card__description').setAttribute('tabindex', tabIndex);
        item.querySelector('.c-carousel-card-button') !== null &&
          item.querySelector('.c-carousel-card-button').setAttribute('tabindex', tabIndex);
        item.querySelector('.c-carousel-card-link') !== null &&
          item.querySelector('.c-carousel-card-link').setAttribute('tabindex', tabIndex);
      }

      function updateCarouselAccessibility(element) {
        var count = 0;
        var slideBy = element.slideBy;

        Array.from(element.slideItems).forEach(function (item, i) {
          if (item.classList.contains('tns-slide-active')) {
            if (i === 0) {
              updateTabIndex(item, 0);
            } else {
              if (count === 0) {
                updateTabIndex(item, -1);
                slideBy++;
              } else {
                var tabIndex = count < slideBy ? 0 : -1;
                updateTabIndex(item, tabIndex);
              }
            }
            count++;
          } else {
            updateTabIndex(item, -1);
          }
        });
      }

      function attachClickEvent(element) {
        var cta = element.querySelectorAll('.js-cta');
        var event = new MouseEvent('click', { view: window, bubbles: true, cancelable: true });
        for (var i = 0; i < cta.length; i++) {
          cta[i].addEventListener('keyup', function (e) {
            e.keyCode === 13 && this.parentElement.dispatchEvent(event);
          });
        }
      }

      var id = carouselId;
      var widget = document.getElementById(id);
      var container = '#' + id + ' .c-carousel-slider';
      var controlsContainer = '#' + id + ' .c-carousel-controls';

      document.querySelector('#' + id).classList.remove('no-js');

      var carousel = new tns({
        container: container,
        items: 3,
        slideBy: 'page',
        navPosition: 'bottom',
        gutter: 10,
        controls: true,
        edgePadding: 10,
        loop: false,
        arrowKeys: true,
        speed: 400,
        controlsContainer: controlsContainer,
        responsive: {
          350: {
            items: 1,
            edgePadding: 30,
          },
          768: {
            items: 2,
            edgePadding: 30,
          },
          1024: {
            items: 3,
            edgePadding: 30,
          },
        },
      });

      attachClickEvent(widget);
      updateCarouselAccessibility(carousel.getInfo());
      carousel.events.on('indexChanged', function (info) {
        updateCarouselAccessibility(info);
      });
      carousel.events.on('newBreakpointEnd', function (info) {
        updateCarouselAccessibility(info);
      });
    }
  }, []);
};

export default useCarousel;
